// extracted by mini-css-extract-plugin
module.exports = {"anchor":"_idgic","disabled":"OPb_m5"};